import { cn } from "@newxsystems/shared";
import { SproutAction } from "../SproutAction/SproutAction";
import { SproutRichText } from "../SproutRichText/SproutRichText";
import type { ISproutCommonContentProps } from "./SproutCommonContent.props";

export const SproutCommonContent = ({
  alignment,
  buttons,
  className,
  description,
  eyebrow,
  heading,
  headingAs = "h2",
  headingClassName,
  tone = "light",
}: ISproutCommonContentProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  const Heading = headingAs;
  const centered = alignment === "center";
  const actions = buttons;

  return (
    <div
      className={cn(
        "flex max-w-[48rem] flex-col gap-4",
        centered && "mx-auto items-center text-center",
        className,
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "w-fit -rotate-1 rounded-[0.55rem_0.55rem_0.55rem_0.15rem] border-2 border-navy-ink bg-sunflower px-4 py-2 font-sprout-mono text-sm font-extrabold leading-[1.4] text-navy-ink shadow-[0_3px_0_#14213d,0_10px_16px_-14px_rgba(20,33,61,0.5)]",
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      {heading ? (
        <Heading
          className={cn(
            "font-sprout-display text-4xl font-bold leading-[1.02] tracking-[-0.03em] text-balance text-foreground [overflow-wrap:anywhere] md:text-6xl",
            tone === "dark" && "text-mineral-gray",
            headingClassName,
          )}
        >
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <SproutRichText
          className={cn(
            "max-w-[65ch]",
            tone === "dark" &&
              "text-mineral-gray [&_a]:text-mineral-gray [&_blockquote]:border-mineral-gray/40 [&_blockquote]:text-mineral-gray",
          )}
          content={description}
        />
      ) : null}
      {actions?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-4", centered && "justify-center")}>
          {actions.map((button, index) => (
            <SproutAction action={button} key={`${button.href}-${index}`} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

SproutCommonContent.displayName = "Content::SproutCommonContent";
